export default {
  OVERTIME_MUTATIONS(state, { key, value }) {
    state[key] = value;
  },
};
